(function () {
  function norm(s) {
    return (s || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  // Runs only on starmap template (caption field exists)
  function isStarMapTemplate() {
    return !!document.querySelector("#starmap_caption");
  }

  /* ============================
     ✅ Caption: show/hide + clear
     ============================ */
  function applyCaptionToggle() {
    const caption = document.getElementById("starmap_caption");
    const ownWrap = document.getElementById("starmap_own_caption_wrap");
    const ownInput = ownWrap ? ownWrap.querySelector("input") : null;

    if (!caption || !ownWrap) return;

    const isOwn = caption.value === "Your Own Caption";
    ownWrap.style.display = isOwn ? "block" : "none";

    // clear value when hidden so it doesn't appear in orders
    if (!isOwn && ownInput) ownInput.value = "";
  }

  /* ============================
     ✅ Variants: hide/show options
     ============================ */
  function getVariantRoot() {
    return (
      document.querySelector("product-info variant-radios") ||
      document.querySelector("product-info variant-selects")
    );
  }

  function getGroups(root) {
    if (!root) return [];
    const fieldsets = Array.from(root.querySelectorAll("fieldset"));
    if (fieldsets.length) return fieldsets;

    // select mode
    return Array.from(root.querySelectorAll("select"))
      .map((s) => s.closest(".product-form__input") || s.parentElement)
      .filter(Boolean);
  }

  function valuesOf(group) {
    const radios = group.querySelectorAll('input[type="radio"]');
    if (radios.length) return Array.from(radios).map((r) => r.value);

    const sel = group.querySelector("select");
    if (sel) return Array.from(sel.options).map((o) => o.value);

    return [];
  }

  function selectedOf(group) {
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    const sel = group.querySelector("select");
    if (sel) return sel.value;

    return "";
  }

  function setSelected(group, value) {
    const radios = group.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      const t = Array.from(radios).find((r) => r.value === value);
      if (t) {
        t.checked = true;
        t.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }

    const sel = group.querySelector("select");
    if (sel) {
      sel.value = value;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function show(el) {
    if (el) el.style.display = "";
  }
  function hide(el) {
    if (el) el.style.display = "none";
  }

  // Identify groups by VALUES (reliable)
  function identifyGroups(groups) {
    const order =
      groups.find((g) => {
        const v = norm(valuesOf(g).join(" | "));
        return v.includes("digital") && v.includes("print") && v.includes("frame");
      }) || null;

    const size =
      groups.find((g) => {
        const v = norm(valuesOf(g).join(" | "));
        return (
          v.includes("a4") ||
          v.includes("a3") ||
          (v.includes("21") && v.includes("30")) ||
          (v.includes("30") && v.includes("40"))
        );
      }) || null;

    const color =
      groups.find((g) => {
        const v = norm(valuesOf(g).join(" | "));
        return v.includes("black") && v.includes("white");
      }) || null;

    return { order, size, color };
  }

  // Hide/show each radio option properly in Dawn (hide label[for=id])
  function setRadioOptionVisible(group, radioInput, visible) {
    const id = radioInput.getAttribute("id");
    const label = id ? group.querySelector(`label[for="${CSS.escape(id)}"]`) : null;

    if (label) label.style.display = visible ? "" : "none";
    radioInput.style.display = visible ? "" : "none";
  }

  // Filter option #2 values depending on mode
  function filterSizeValues(sizeGroup, mode) {
    if (!sizeGroup) return;

    const allowPrint = (v) => v.includes("a4") || v.includes("a3");
    const allowFrame = (v) =>
      (v.includes("21") && v.includes("30")) || (v.includes("30") && v.includes("40"));

    const allowedFn = mode === "print" ? allowPrint : allowFrame;

    // radios mode
    const radios = sizeGroup.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      let firstAllowed = null;

      Array.from(radios).forEach((r) => {
        const v = norm(r.value);
        const ok = allowedFn(v);
        setRadioOptionVisible(sizeGroup, r, ok);
        if (ok && !firstAllowed) firstAllowed = r.value;
      });

      const checked = sizeGroup.querySelector('input[type="radio"]:checked');
      if (!checked || !allowedFn(norm(checked.value))) {
        if (firstAllowed) setSelected(sizeGroup, firstAllowed);
      }
      return;
    }

    // select mode
    const sel = sizeGroup.querySelector("select");
    if (sel) {
      let firstAllowed = null;

      Array.from(sel.options).forEach((opt) => {
        const v = norm(opt.value);
        const ok = allowedFn(v);
        opt.hidden = !ok;
        opt.disabled = !ok;
        if (ok && !firstAllowed) firstAllowed = opt.value;
      });

      const current = norm(sel.value);
      if (!sel.value || sel.options[sel.selectedIndex]?.disabled || !allowedFn(current)) {
        if (firstAllowed) {
          sel.value = firstAllowed;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  }

  function applyVariants() {
    if (!isStarMapTemplate()) return;

    const root = getVariantRoot();
    if (!root) return;

    const groups = getGroups(root);
    const { order, size, color } = identifyGroups(groups);
    if (!order) return;

    const orderVal = norm(selectedOf(order));

    const isDigital = orderVal.includes("digital");
    const isPrint = orderVal.includes("print only");
    const isFrame = orderVal.includes("in a frame");

    if (isDigital) {
      hide(size);
      hide(color);
      return;
    }

    if (isPrint) {
      show(size);
      hide(color);
      filterSizeValues(size, "print"); // ONLY A4/A3
      return;
    }

    if (isFrame) {
      show(size);
      show(color);
      filterSizeValues(size, "frame"); // ONLY 21x30 / 30x40
      return;
    }

    show(size);
    show(color);
  }

  function applyAll() {
    if (!isStarMapTemplate()) return;
    applyCaptionToggle();
    applyVariants();
  }

  document.addEventListener("DOMContentLoaded", function () {
    applyAll();

    // Keep working after user changes options
    document.addEventListener("change", function () {
      setTimeout(applyAll, 20);
    });

    document.addEventListener("variant:change", function () {
      setTimeout(applyAll, 20);
    });

    // Re-apply when Dawn re-renders sections
    const obs = new MutationObserver(function () {
      applyAll();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
